import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      aria-label="Toggle theme"
      className="inline-flex items-center gap-2 px-3 py-2 rounded-full border border-border text-xs font-mono uppercase tracking-wider hover:bg-secondary transition-colors duration-200"
    >
      {theme === "dark" ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
      <span>{theme === "dark" ? "light" : "dark"}</span>
    </button>
  );
}
